<template>
  <ul class="sel-lang line-sel-wrap">
    <li
      v-for="country in countryStore.countries"
      :key="country.code"
      :class="{ on: country.code === selectedCountry?.code }"
      @click="handleCountryChange(country)"
    >
      <span>{{ country.name }}</span>
      <IconCheck></IconCheck>
    </li>
  </ul>
</template>

<script setup lang="ts" generic="T = unknown">
import { onMounted, ref } from 'vue';

import { fetchUserCountry } from '@/api/apiService';
import IconCheck from '@/components/jh-app/icons/IconCheck.vue';
import { useCountryStore } from '@/stores/country';
import { Country } from '@/types/components';

const props = withDefaults(
  defineProps<{
    payload?: Country | null;
  }>(),
  {
    payload: null,
  }
);
const emit = defineEmits<{ confirm: [country: Country]; close: [] }>();

const countryStore = useCountryStore();

const selectedCountry = ref<Country | null>(null);

const handleCountryChange = (country: Country) => {
  selectedCountry.value = country;
  emit('confirm', country);
  emit('close');
};

const requestUserCountry = async () => {
  try {
    const { data } = await fetchUserCountry();
    const countryIsoCode = data.countryIsoCode;

    if (countryIsoCode) {
      selectedCountry.value = countryStore.getCountryByCode(countryIsoCode);
    }
  } catch (error) {
    console.error(error);
  }
};

onMounted(async () => {
  if (!props.payload) {
    await requestUserCountry();
  }

  selectedCountry.value = props.payload;
});
</script>

<style scoped lang="scss">
.line-sel-wrap {
  max-height: 50vh;
  min-height: 50vh;
  margin-top: 1rem;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  li {
    padding: 1rem 0;
    border-bottom: 1px solid $color-gray-40;
    display: flex;
    justify-content: space-between;
    span {
      font-size: $font-size-psmall;
    }
    svg {
      color: $color-navy-100;
      opacity: 0;
    }
    &.on {
      span {
        color: $color-navy-100;
      }
      svg {
        opacity: 1;
      }
    }
    &.last-txt {
      font-size: $font-size-psmall;
      justify-content: center;
      border-bottom: 0;
    }
  }
}
</style>
